import React, { useState } from "react";
import axios from "../../api/axios.js";
import { getFetchOptions } from "../../js/utility.js";

const ResetPassword = () => {
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const token = window.location.pathname.split("/").pop();

  const handleSendNewPassword = async () => {
    if (newPassword !== confirmPassword) {
      alert("Le password non corrispondono");
      return;
    }

    const fetchCheckOptions = getFetchOptions(
      "application/json",
      { token, newPassword },
      "POST"
    );
    await fetch(
      `${axios.defaults.baseBFFUrl}/fe/resetPassword`,
      fetchCheckOptions
    )
      .then((response) => {
        response.json().then((result) => {
          if (!result.error) {
            alert("Password aggiornata con successo");
            window.location.href = "/login";
          } else {
            alert(
              "Errore durante l'aggiornamento della password: " + result.message
            );
          }
        });
      })
      .catch((error) => {
        alert(
          "Errore durante l'aggiornamento della password: " + error.message
        );
      });
  };

  return (
    <div className="main-wrapper">
      <div className="main-content mt-5">
        <div className="container d-flex flex-column justify-content-center align-items-center">
          <div className="row w-25 mb-3">
            <img
              src="/assets/images/brand-logos/desktop-logo.png"
              alt="logo"
              className="desktop-logo"
            />
          </div>
          <div className="row w-50">
            <div className="col">
              <div className="card">
                <div className="card-header text-center">
                  <span>Reset Password</span>
                </div>
                <div className="card-body">
                  <form>
                    <div className="form-group">
                      <label>Nuova password</label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <div className="form-group">
                      <label>Conferma password</label>
                      <input
                        type="password"
                        className="form-control"
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <div className="d-flex justify-content-end align-items-center">
                      <button
                        type="button"
                        className="btn btn-primary mt-3"
                        onClick={handleSendNewPassword}
                      >
                        Invia
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
